import React, { Component } from 'react'
import LogoPaggingGFS from './../Images/pagging-gfs.svg'
import LogoPaggingO from './../Images/pagging-o.svg'
import LogoPaggingFT from './../Images/pagging-ft.svg'
import FontAwesome from 'react-fontawesome'

export class Pagination extends Component {

    constructor(props) {
        super(props)
    
        this.state = {
             pager: []
        }
    }

    // componentDidMount() {
        
    //     const { totalpage, recordperpage} = this.props
    //     const totalpager = (totalpage > recordperpage) ? recordperpage : totalpage
    //     const activepage = Number(this.props.activepage)

    //     var startpage 
    //     var endpage

    //     if (totalpage > recordperpage && totalpage === activepage) {
    //         startpage = activepage - 9
    //         endpage = totalpage
    //     } else if ((6 < activepage) && (totalpage > activepage)) {
    //         if((activepage+4) > totalpage) {
    //             startpage = totalpage-9
    //             endpage = totalpage
    //         } else {
    //             startpage = activepage-5
    //             endpage = activepage+4    
    //         }
    //     } else {
    //         startpage = 1
    //         endpage = totalpager
    //     }

    //     for(let i=startpage; i<=endpage; i++) {
    //         this.setState(prevState => ({
    //             pager: [...prevState.pager, i]
    //         }))
    //     }
    // }

    handleClick(page){
        this.props.history.push(this.props.urlparampagging+'&page='+page)
        window.scrollTo(0, 0)
    }
    

    render() {
        const { totalpage } = this.props
        const activepage = Number(this.props.activepage) // we separate as can use direct Number function
        const limitperpager = 10
        const totalpager = (totalpage > limitperpager) ? limitperpager : totalpage
        const pagginglist = []
        var startpage 
        var endpage

        if (totalpage > limitperpager && totalpage === activepage) {
            startpage = activepage - 9
            endpage = totalpage
        } else if ((6 < activepage) && (totalpage > activepage)) {
            if((activepage+4) > totalpage) {
                startpage = totalpage-9
                endpage = totalpage
            } else {
                startpage = activepage-5
                endpage = activepage+4    
            }
        } else {
            startpage = 1
            endpage = totalpager
        }

        for(let i=startpage; i<=endpage; i++) {
            pagginglist.push(<div key={i}>{(activepage===i) ? <><img src={LogoPaggingO} alt="GFSOFT"/><br/><span><b>{i}</b></span></> : <span onClick={() => this.handleClick(i)} title={i}><img src={LogoPaggingO} alt="GFSOFT"/><br/>{i}</span>}</div>)
        }

        if(1 < totalpage) {
            return (
                <div className="pagging">
                    <div className={(3 > activepage) ? 'invisible' : ''}><span onClick={() => this.handleClick(1)} title="Pertama"><FontAwesome className="fontawesome" name="angle-double-left"/><br/>First</span></div>
                    <div>{(2 > activepage) ? <img src={LogoPaggingGFS} alt="GFSOFT"/> : <span onClick={() => this.handleClick(activepage-1)} title="Sebelumnya"><img src={LogoPaggingGFS} alt="GFSOFT"/><br/>Previous</span>}</div>
                    {/* {this.state.pager.map((pager, key) => {
                        return (<div key={key}>{(activepage===pager) ? <><img src={LogoPaggingO} alt="GFSOFT"/><br/><span><b>{pager}</b></span></> : <Link to={`${urlparampagging}&page=${pager}`} title={pager}><img src={LogoPaggingO} alt="GFSOFT"/><br/><span>{pager}</span></Link>}</div>)
                    })} */}
                    {pagginglist}
                    <div>{(activepage === totalpage) ? <img src={LogoPaggingFT} alt="GFSOFT"/> : <span onClick={() => this.handleClick(activepage+1)} title="Selanjutnya"><img src={LogoPaggingFT} alt="GFSOFT"/><br/>Next</span>}</div>
                    <div className={(2 > (totalpage-activepage)) ? 'invisible' : ''}><span onClick={() => this.handleClick(totalpage)} title="Terakhir"><FontAwesome className="fontawesome" name="angle-double-right"/><br/>Last</span></div>
                </div>
            )
        } else {
            return ''
        }
    }
}

export default Pagination